import axios from 'config/axios';
import { FeedOption } from '../feeds.types';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

type Response = {
    config: FeedOption[];
};

async function getFeedOptions(purposeId: string) {

    const response = await axios.get<Response>('GetFeedConfigOptions', {
      params: { purposeId },
    });
    return response.data.config;
  } 

const useFeedOptions = (purposeId: string) =>
  useQuery<FeedOption[], AxiosError>(['feedOptions', purposeId], () =>
    getFeedOptions(purposeId)
  );

export default useFeedOptions;
